module.exports = __webpack_public_path__ + "static/hero-welder-01-ed2102fec687daa131b9629b327479a7.jpg";